// extracted by mini-css-extract-plugin
export default {"chips":"CustomChips_chips__bUDQl"};